import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BLUE_LIGHT, BLUE_LIGHT_DISABLED, GRAY, GRAY_DARK, RED, RED_LIGHTER} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

export enum ClickableIconStyle {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NEGATIVE_RED = 'NEGATIVE_RED',
}

// Map of icon style -> disabled/enabled -> color
const ICON_STYLE_TO_COLORS: Record<ClickableIconStyle, Record<'enabled' | 'disabled', string>> = {
  [ClickableIconStyle.POSITIVE]: {
    enabled: BLUE_LIGHT,
    disabled: BLUE_LIGHT_DISABLED,
  },
  [ClickableIconStyle.NEGATIVE]: {
    enabled: GRAY_DARK,
    disabled: GRAY,
  },
  [ClickableIconStyle.NEGATIVE_RED]: {
    enabled: RED,
    disabled: RED_LIGHTER,
  },
};

export default function ClickableIcon({
  altText,
  className,
  disabled,
  iconStyle,
  icon,
  onClick,
  dataTestAttrs,
}: {
  altText?: string;
  className?: string;
  disabled?: boolean;
  icon: BenchlingIconName;
  iconStyle: ClickableIconStyle;
  onClick?: (e: ElementMouseEvent) => void;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <BenchlingIcon
      aria-label={altText}
      aria-disabled={disabled}
      altText={altText}
      style={{
        color: ICON_STYLE_TO_COLORS[iconStyle][disabled ? 'disabled' : 'enabled'],
      }}
      className={classNames(className, {
        [css(styles.enabledIcon)]: !disabled,
        [css(styles.disabledIcon)]: disabled,
      })}
      {...getActionButtonRoleProps({
        onPress: (e) => {
          if (!disabled) {
            onClick?.(e as ElementMouseEvent);
          }
        },
      })}
      icon={icon}
      dataTestAttrs={dataTestAttrs}
    />
  );
}

const styles = StyleSheet.create({
  enabledIcon: {
    cursor: 'pointer',
  },
  disabledIcon: {
    cursor: 'not-allowed',
  },
});
